import { createDefault } from "../../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "承認待ち", enum: "NEW" },
  { value: 2, text: "納品予約待ち", enum: "RESERV_WAIT" },
  { value: 3, text: "入荷待ち", enum: "WAITING" },
  { value: 4, text: "検品済み", enum: "INSPECTED" },
  { value: 5, text: "キャンセル", enum: "CANCELED" },
]);
